<div class="row mt-3" *ngIf="canBegin">
  <div class="col">
    <button class="btn btn-raised btn-primary" (click)="beginOptionalRoute()">
      Begin
    </button>
  </div>
</div>

<div class="row mt-3" *ngIf="canCancel">
  <div class="col">
    <button class="btn btn-raised btn-danger" (click)="cancelOptionalRoute()">
      Cancel
    </button>
  </div>
</div>
